import Component from 'flarum/common/Component';
/**
 * When extending this component, you get access to the item definition via `this.attrs.definition`.
 */
export default class MobileTabComponent extends Component {}
flarum.reg.add('acpl-mobile-tab', 'common/components/MobileTabComponent', MobileTabComponent);